export default "__VITE_ASSET__5a998910__"